"use client"

import { useFetchOpportunity } from "@/hooks/api/opportunities/queries"
import { useLoadingRouter } from "@/hooks/use-loading-router"

export function OpportunityLink({
  pipelineId,
  opportunityId,
  label,
}: {
  pipelineId: string
  opportunityId: string
  label: string
}) {
  const { refetch, isFetching } = useFetchOpportunity(pipelineId, opportunityId, false)
  const { push } = useLoadingRouter()

  return (
    <a
      href="#"
      aria-busy={isFetching}
      onClick={async (event) => {
        event.preventDefault()
        event.stopPropagation()
        if (isFetching) return
        const { data: opportunity } = await refetch()
        if (!opportunity) return
        const params = new URLSearchParams({
          pipelineId: opportunity.pipeline_id,
          opportunityId: opportunity.id,
          bookId: opportunity.book_id,
        })
        push(`/opportunities?${params}`)
      }}
      className="cursor-pointer border-b border-dashed border-current/40 text-inherit transition-colors duration-150 hover:border-current"
    >
      {label}
    </a>
  )
}
